import React from 'react'
import Ryzyka from '../../common/pages/Ryzyka.jsx'

const S1_Ryzyka = (props) => {
    return (
        <Ryzyka data={props}/>
    )
}

export default S1_Ryzyka

